import {styled} from '@esgi/ui/theme';
import {Tabs} from '../../../../tabs';

export const TabContent = styled(Tabs.TabContent, {
	overflow: 'hidden',
});
